import { useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

// Listens for navigation messages from the SW (e.g. push-notification clicks
// asking the SPA to navigate to a URL). Mutation queueing is handled entirely
// by TanStack Query's persisted/paused mutations — see main.tsx.
export function useServiceWorkerNavigate() {
  const navigate = useNavigate()

  const handleMessage = useCallback(
    (event: MessageEvent) => {
      if (event.data?.type === 'NAVIGATE') {
        const url = event.data.url as string | undefined
        if (url) navigate(url)
      }
    },
    [navigate],
  )

  useEffect(() => {
    navigator.serviceWorker?.addEventListener('message', handleMessage)
    return () => {
      navigator.serviceWorker?.removeEventListener('message', handleMessage)
    }
  }, [handleMessage])
}
